import { Form } from 'antd'
import { useDispatch } from 'react-redux'
import { Button, BUTTON_TYPES } from '../../../../../../components/Button'
import { Popup } from '../../../../../../components/Popup'
import { Forms } from '../../../../../../components/Forms'
import { prepareFormData } from './utils'
import { saveSplitFees } from './api'
import { useLedByCommunityListContext } from '../../LedByCommunityContextProvider'
import { setLoading } from '../../../../../../redux/store/common/slice'
import { BTN_TXT } from '../../../../../../constants'
import { TEditCommunityFeesForm } from '../../../../../../components/Forms/forms.editCommunityFees.d'
import { EditFeesRequestData } from './types'
import { useSplitFeesPopup } from '../../../../SplitFees/Providers/SplitFeesPopupProvider'
import { useMemo } from 'react'

export const EditFeesPopup = () => {
  const {
    editLedByCommunityPopup: { actions, state }
  } = useSplitFeesPopup()
  const [form] = Form.useForm<TEditCommunityFeesForm>()
  const dispatch = useDispatch()
  const {
    actions: { getTableData }
  } = useLedByCommunityListContext()

  const { selectedRows } = state.payload

  const onClosePopup = () => {
    actions.close()
    form.resetFields()
  }

  const parsedFormData = useMemo(
    () => selectedRows && prepareFormData(selectedRows),
    [selectedRows]
  )

  const canEditGPOAllocation = useMemo(() => {
    if (selectedRows) {
      return selectedRows[0].canEditGPORetain
    }
    return false
  }, [selectedRows])

  const onSubmitFees = async (values: TEditCommunityFeesForm) => {
    try {
      dispatch(setLoading(true))
      const data: EditFeesRequestData[] = values.health_systems.map(
        (splitFeeData) => {
          const hs_data: EditFeesRequestData = {
            split_fee: splitFeeData.uuid,
            community_split: splitFeeData.co_retain,
            hs_split: splitFeeData.hs_split,
            gpo_retain: values.gpo_allocation
              ? String(values.gpo_allocation)
              : null
          }
          return hs_data
        }
      )
      await saveSplitFees(data)
      await getTableData()
      onClosePopup()
    } finally {
      dispatch(setLoading(false))
    }
  }

  if (!parsedFormData) return null

  return (
    <Popup
      visible={state.visible}
      title="Edit Fees"
      width={447}
      onCancel={onClosePopup}
      footer={
        <>
          <Button type={BUTTON_TYPES.DEFAULT} onClick={onClosePopup} upperCase>
            {BTN_TXT.CANCEL}
          </Button>
          <Button
            type={BUTTON_TYPES.PRIMARY}
            form="edit-community-admin-fees"
            htmlType="submit"
            upperCase
          >
            {BTN_TXT.SAVE}
          </Button>
        </>
      }
    >
      <Forms.EditCommunityFees
        form={form}
        onSubmitFees={onSubmitFees}
        initialData={parsedFormData}
        canEditGPOAllocation={canEditGPOAllocation}
      />
    </Popup>
  )
}
